import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldOff, ArrowLeft, Home } from 'lucide-react';
import { useAuth, useRole } from '../context/AuthContext';

export function UnauthorizedPage() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const { role } = useRole();
  
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <div className="mx-auto w-24 h-24 bg-red-500/20 rounded-full flex items-center justify-center mb-4">
            <ShieldOff className="h-12 w-12 text-red-500" />
          </div>
          
          <h1 className="text-3xl font-bold text-white mb-2">
            Brak uprawnień
          </h1>
          
          <p className="text-gray-400">
            {isAuthenticated && role ? (
              <>
                Twoja rola <span className="text-orange-400 font-medium">{role.display_name}</span> nie ma dostępu do tej sekcji.
              </>
            ) : (
              'Nie masz uprawnień do wyświetlenia tej strony.'
            )}
          </p>
        </div>
        
        <div className="space-y-3">
          <button
            onClick={() => navigate(-1)}
            className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-gray-800 text-gray-300 rounded-lg hover:bg-gray-700 transition-colors"
          >
            <ArrowLeft className="h-5 w-5" />
            <span>Wróć do poprzedniej strony</span>
          </button>
          
          <button
            onClick={() => navigate('/dashboard')}
            className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors"
          >
            <Home className="h-5 w-5" />
            <span>Przejdź do pulpitu</span>
          </button>
        </div>
        
        <div className="mt-8 p-4 bg-gray-800/50 rounded-lg border border-gray-700">
          <p className="text-sm text-gray-400">
            Jeśli uważasz, że powinieneś mieć dostęp do tej sekcji, skontaktuj się z administratorem systemu.
          </p>
        </div>
      </div>
    </div>
  );
}
